import { type ReactElement } from 'react';
import cx from 'clsx';
import styles from './avatar.module.css';
import { type AvatarIconSize } from './config';

export interface AvatarIconOverlayProps {
  children: ReactElement;
  iconAltValue?: string;
  iconSize?: AvatarIconSize;
  iconTestId?: string;
}

const DEFAULT_ICON_SIZE: AvatarIconSize = '16';

export function AvatarIconOverlay({
  children,
  iconAltValue,
  iconSize = DEFAULT_ICON_SIZE,
  iconTestId = '',
}: AvatarIconOverlayProps): ReactElement {
  return (
    <div
      aria-hidden={iconAltValue ? 'false' : 'true'}
      className={cx(styles['avatar-icon'], styles[`avatar-icon-${iconSize}`])}
      data-testid={iconTestId}
      title={iconAltValue}
    >
      {children}
    </div>
  );
}
